import { useEffect, useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import AddRoleToPermitTypeForm, { FormData } from "./AddRoleToPermitTypeForm";
import { FormError } from "../models/FormError";
import { OrgRole } from "../models/OrgRole";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (selectedOrgRoleIds: string[]) => void;
  submitInProgress: boolean;
  submitErrors?: string[];
  availableOrgRoles: OrgRole[];
}

const AddRoleToPermitTypeModal = ({
  open,
  onClose,
  onSubmit,
  submitInProgress,
  submitErrors,
  availableOrgRoles,
}: Props) => {
  const [formData, setFormData] = useState<FormData>({} as FormData);
  const [formErrors, setFormErrors] = useState<FormError>({});
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    setFormData({} as FormData);
    setFormErrors({} as FormError);
    setHasSubmitted(false);
  }, [open]);

  const validateFormData = (data: FormData): FormError => {
    const formError: FormError = {};

    if (!data.orgRoleIds || data.orgRoleIds.length < 1) {
      formError.orgRoleIds = "Please select at least one role";
    }

    return formError;
  };

  const handleSubmit = () => {
    setHasSubmitted(true);

    const validationErrors = validateFormData(formData);
    setFormErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      onSubmit(formData.orgRoleIds);
    }
  };

  const handleFormChange = (data: FormData) => {
    if (hasSubmitted) {
      setFormErrors(validateFormData(data));
    }

    setFormData({ ...data });
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} size="small">
      <Modal.Header>Add roles to permit type</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <AddRoleToPermitTypeForm
            formData={formData}
            formErrors={formErrors}
            errors={submitErrors}
            onChange={handleFormChange}
            availableOrgRoles={availableOrgRoles}
          />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} positive loading={submitInProgress} disabled={submitInProgress}>
          Ok
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AddRoleToPermitTypeModal;

